export default __webpack_public_path__ + "static/media/sks.37b39ead.JPG";